import React, { useCallback } from "react";

import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "components/Form";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "components/MaterialDialog";
import { acknowledgeScannerDisconnect } from "actions";
import { DisconnectCause } from "constants/scanner";
import { useDispatch, useSelector } from "react-redux";
import { getUnexpectedScannerDisconnectCause } from "selectors";

export function ScannerDisconnectedDialog() {
  const dispatch = useDispatch();
  const cause = useSelector<State, DisconnectCause>(
    getUnexpectedScannerDisconnectCause,
  );

  const onClose = useCallback(() => {
    dispatch(acknowledgeScannerDisconnect());
  }, [dispatch]);

  return (
    <Dialog open={Boolean(cause)} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        onClose={onClose}
        icon={faExclamationTriangle}
        iconColor="warning"
      >
        Scanner Disconnected
      </DialogTitle>
      <DialogContent>
        {cause === DisconnectCause.HUB && "Lost connection to AgriNous Hub."}
        {cause === DisconnectCause.SCANNER &&
          "Please check the device and reconnect to continue scanning."}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Dismiss</Button>
      </DialogActions>
    </Dialog>
  );
}
